export const CustomWidgetParams = {
    User: 'User',
};
